var React = require('react');

function KatalogIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.7199 0H9.31084C6.38191 0 3.81989 1.76821 3.81989 4.69841V22.0774L11.7191 10.9091H16.2401L2 32.1212H7.90508L24.5993 7.87876H29.1197L7.01109 40H13.2135L27.4657 18.7879H31.9861L21.2971 34.5454H33.7199C36.6501 34.5454 38.9715 32.0364 38.9715 29.1074V4.69841C38.9715 1.76821 36.6501 0 33.7199 0Z","fill":"#fff"}));
}

KatalogIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = KatalogIcon;

KatalogIcon.default = KatalogIcon;
